import { render } from "./AddQuotePage.vue?vue&type=template&id=6adaa3b4&scoped=true"
import script from "./AddQuotePage.vue?vue&type=script&lang=js"
export * from "./AddQuotePage.vue?vue&type=script&lang=js"

import "./AddQuotePage.vue?vue&type=style&index=0&id=6adaa3b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adaa3b4"]])

export default __exports__